import { Button } from '@rcg/ui-components';
import styled, { AnyStyledComponent } from 'styled-components';
import { BrandCode } from 'types';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import { CruiseDetailsCloseButton } from 'components/CruiseDetailsPanel/RefinedCruiseDetailsPanel/RefinedCruiseDetails.styles';
import { CruiseCardBase } from '../CruiseCard.styles';

export const MapCruiseCardContainer = styled(CruiseCardBase)`
	display: flex;
	flex-direction: column;
	min-height: 150px;
	background-color: ${colors.primary.ice};
	position: relative;
	flex-direction: column;
	margin-left: auto;
	margin-right: auto;

	${({ theme }) => ({
		[BrandCode.Celebrity]: `
			padding: 30px 20px;
			box-shadow: 0 4px 4px 0 #00000040;
			max-width: 1300px;

			@media (min-width: ${sizes.media.tabletMinWidth}px) {
				padding: 30px;
				min-height: 350px;
			}
    `,
		[BrandCode.RoyalCaribbean]: `
			padding: 20px;
			box-shadow: 0 0 8px #0000001A;
			max-width: 1220px;

			@media (min-width: ${sizes.media.tabletMinWidth}px) {
				padding: 30px;
				min-height: 252px;
			}
    `,
	})[theme.brandCode]}
`;

export const MapCruiseCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      padding-top: 10px;
    `,
  })[theme.brandCode]};
`;

export const MapCruiseCardNights = styled.div`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-style: normal;
	text-transform: uppercase;

  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      font-size: 15px;
      letter-spacing: 0.3px;
			line-height: 120%;
			font-family: ${theme.typography.fontFamilySemiBold};
    `,
    [BrandCode.RoyalCaribbean]: `
			font-size: 16px;
			letter-spacing: 0.32px;
			line-height: 125%;
			font-family: ${theme.typography.fontFamilyBold};

			@media (min-width: ${sizes.media.tabletPortrait}px) {
				font-size: 18px;
				letter-spacing: 0.36px;
      }

			@media (min-width: ${sizes.media.mediumMaxWidth}px) {
				font-size: 22px;
				letter-spacing: 0.44px;
      }
    `,
  })[theme.brandCode]}
`;

export const MapCruiseCardName = styled.div`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-style: normal;

  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      font-size: 24px;
      line-height: 120%;
      letter-spacing: -0.48px;
			margin-bottom: 20px;

      @media (min-width: ${sizes.media.tabletMinWidth}px) {
        font-size: 28px;
        letter-spacing: -0.56px;
      }
    `,
    [BrandCode.RoyalCaribbean]: `
			font-size: 20px;
			line-height: 125%;
			letter-spacing: -0.4px;
			margin-bottom: 10px;

			@media (min-width: ${sizes.media.tabletPortrait}px) {
				font-size: 24px;
				letter-spacing: -0.48px;
			}

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
				font-size: 30px;
				letter-spacing: -0.6px;
      }
    `,
  })[theme.brandCode]}
`;

export const MapCruiseCardLabelContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 21px;
	margin-top: -10px;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
			line-height: 21px;
			font-size: 14px;
    `,
			[BrandCode.RoyalCaribbean]: `
				&.legacyCard {
					margin: 10px 0 20px 0 !important;
				}
    `,
		})[theme.brandCode]}
`;

export const MapCruiseCardLabel = styled(Button as AnyStyledComponent)`
	text-transform: capitalize !important;
	font-weight: 600 !important;
	margin: 0 !important;

	font-family: ${({ theme }) => theme.typography.fontFamilySemiBold};

	&.itineraryCard:hover {
		background-color: ${colors.primary.ice};
	}

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
			&.itineraryCard {
				height: inherit;
				text-decoration: underline;
				padding: 3px;
				font-size: 14px;
			}

    `,
			[BrandCode.RoyalCaribbean]: `
			&.itineraryCard {
				height: inherit;
				padding: 2px;
				font-size: 16px;
				line-height: 19.5px;
				letter-spacing: -0.02em;
			}
    `,
		})[theme.brandCode]}
`;

export const MapCruiseCardCloseButton = styled(CruiseDetailsCloseButton)`
	position: absolute;
	padding: 10px 10px;

	${({ theme }) => ({
		[BrandCode.Celebrity]: `
			top: 10px;
			right: 20px;

			@media (min-width: ${sizes.media.tabletLandscape}px) {
				top: 20px;
			}
		`,
		[BrandCode.RoyalCaribbean]: `
			top: 20px;
			right: 20px;

			@media (min-width: ${sizes.media.tabletMinWidth}px) {
				top: 30px;
				right: 30px;
			}
		`,
	})[theme.brandCode]}
`;

export const MapCruiseCardGridSection = styled.section`
`;